<template>
  <div id="main" class="container">
    <alert-area class="my-3" :alerts="alerts"></alert-area>
    <h2 class="my-3">Config</h2>
    <div class="px-3">

      <div class="row my-2">
        <div class="col-md-8 border-right pb-2">
          <h4>On-Load Stamp</h4>
          <small class="text-secondary">
            Stamping automatically when accessing this app.
          </small>
        </div>
        <div class="col-md-4 pt-1">
          <toggle-button :is-on="preferences.onLoadStamp"
            @click="togglePreference('onLoadStamp')"></toggle-button>
        </div>
      </div>

      <div class="row my-2">
        <div class="col-md-8 border-right pb-2">
          <h4>Auto Read-more</h4>
          <small class="text-secondary">
            Loading more records automatically when scrolled down.
          </small>
        </div>
        <div class="col-md-4 pt-1">
          <toggle-button :is-on="preferences.autoReadMore"
            @click="togglePreference('autoReadMore')"></toggle-button>
        </div>
      </div>

      <div class="row my-2">
        <div class="col-md-8 border-right pb-2">
          <h4>Delete All</h4>
          <small class="text-secondary">
            Delete your all timestamp data saved in your browser.
            Now your data size is estimated {{ stampDataSize | byte }}.
          </small>
        </div>
        <div class="col-md-4 pt-1">
          <button class="btn btn-sm btn-outline-danger" @click="deleteAll()">DELETE ALL RECORDS</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import AlertArea from '../components/AlertArea.vue'
import ToggleButton from '../components/ToggleButton.vue'
import alerts from '../resources/alerts.js'
import common from '../resources/common.js'

export default {
  name: 'Config',
  components: {
    AlertArea, ToggleButton
  },
  data: function() {
    return {
      alerts: [],
      preferences: {
        onLoadStamp: false,
        autoReadMore: false,
      },
    };
  },
  created: function() {
    if (!common.storageAvailable('localStorage')) {
      this.alerts.push(alerts.d01);
      return;
    }
    let storage = window.localStorage;
    let preferences = storage.getItem('preferences');
    if(preferences) {
      preferences = JSON.parse(preferences);
      this.preferences['onLoadStamp'] = !!preferences['onLoadStamp'];
      this.preferences['autoReadMore'] = !!preferences['autoReadMore'];
    }
  },
  watch: {
    preferences: {
      handler: 'savePreferences',
      deep: true,
    },
  },
  computed: {
    stampDataSize: function() {
      let result = 0;
      if(common.storageAvailable) {
        let storage = window.localStorage;
        let storageStamp = storage.getItem('stamps');
        if(storageStamp) {
          result = storageStamp.length;
        }
      }
      return result;
    },
  },
  filters: {
    byte: function (value) {
      const units = ['Byte', 'kB', 'MB'];
      let border = 0x400;
      let result = value;
      let i = 0; // index of units
      while (i < units.length - 1 && value >= border) {
        result = value / border;
        i++;
        border <<= 10;
      }

      // fix number, expect Byte scale
      if(i > 0) {
        if(result >= 100) {
          result = result.toFixed(); // 123 UN
        } else if(result >= 10) {
          result = result.toFixed(1); // 12.3 UN
        } else {
          result = result.toFixed(2); // 1.23 UN
        }
      }

      return `${result} ${units[i]}`;
    },
  },
  methods: {
    savePreferences: function(newPrefs) {
      window.localStorage.setItem('preferences', JSON.stringify(newPrefs));
    },
    togglePreference: function(name) {
      this.preferences[name] = !this.preferences[name];
    },    
    deleteAll: function() {
      if(confirm('Your stamp data will be never recovered!\nAre you sure you want to delete all records?')) {
        window.localStorage.removeItem('stamps');
        this.alerts.push({
          type: "success",
          message: "Complete to delete your all records."
        });
      }
    },
  },
}
</script>
